'use client'
import CampaignListing from "./CampaignListing"

const MyCampaigns = () => {
  return (
    <CampaignListing />
  )
}

export default MyCampaigns
